import * as Type from './actionsTypes';

const INITIAL_STATE = {
  moduleConfigurations: [],
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case Type.FETCH_MODULE_CONFIGURATION_SUCCESS: {
      return {
        ...state,
        moduleConfigurations: action.data,
      }
    }
    case Type.CLEAR_MODULE_CONFIGURATION: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}

export const getModuleConfigurations = state => state.rootState.moduleConfiguration.moduleConfigurations;
